export const tableColors = [
  {
    backgroundColor: '#DFF2E8',
    backgroundColorTable: 'rgba(223, 242, 232, 0.5)',
    color: '#37AB6E',
    backgroundChildColor: '#C7E8D6'
  },
  {
    backgroundColor: '#F7FEE7',
    backgroundColorTable: 'rgba(247, 254, 231, 0.5)',
    color: '#BFD390',
    backgroundChildColor: '#E7F1CF'
  },
  {
    backgroundColor: '#EFF6FF',
    backgroundColorTable: 'rgba(239, 246, 255, 0.5)',
    color: '#91B0D3',
    backgroundChildColor: '#E3EBF4'
  },
  {
    backgroundColor: '#F0FDF4',
    backgroundColorTable: 'rgba(240, 253, 244, 0.5)',
    color: '#79BE8E',
    backgroundChildColor: '#DBF9E4'
  },
  {
    backgroundColor: '#FFF1F2',
    backgroundColorTable: 'rgba(255, 241, 242, 0.5)',
    color: '#D18F91',
    backgroundChildColor: '#F5DEDF'
  },
  {
    backgroundColor: '#f3eeee',
    backgroundColorTable: 'rgba(250, 250, 250, 0.5)',
    color: '#B4B4B4',
    backgroundChildColor: '#EAEAEA'
  },
  {
    backgroundColor: '#FFF7ED',
    backgroundColorTable: 'rgba(255, 247, 237, 0.5)',
    color: '#C1B19E',
    backgroundChildColor: '#F3E9DD'
  },
  {
    backgroundColor: '#FDF2F8',
    backgroundColorTable: 'rgba(253, 242, 248, 0.5)',
    color: '#CDA6BB',
    backgroundChildColor: '#F8E3EE'
  },
  {
    backgroundColor: '#e7eef6',
    backgroundColorTable: 'rgba(248, 251, 255, 0.5)',
    color: '#8FA9CE',
    backgroundChildColor: '#E9F1FD'
  },
  {
    backgroundColor: '#FEFCE8',
    backgroundColorTable: 'rgba(254, 252, 232, 0.5)',
    color: '#B8B277',
    backgroundChildColor: '#EEECD4'
  },
  {
    backgroundColor: '#EBE9FE',
    backgroundColorTable: 'rgba(235, 233, 254, 0.5)',
    color: '#9692E0',
    backgroundChildColor: '#DFDDFA'
  },
  {
    backgroundColor: '#FEF2F2',
    backgroundColorTable: 'rgba(254, 242, 242, 0.5)',
    color: '#D39D9D',
    backgroundChildColor: '#FAE6E6'
  },
  {
    backgroundColor: '#ECFDF3',
    backgroundColorTable: 'rgba(236, 253, 243, 0.5)',
    color: '#79AE8F',
    backgroundChildColor: '#D6F6E3'
  },
  {
    backgroundColor: '#EEF4FF',
    backgroundColorTable: 'rgba(238, 244, 255, 0.5)',
    color: '#849DC9',
    backgroundChildColor: '#DDE5F4'
  },
  {
    backgroundColor: '#FFFAEB',
    backgroundColorTable: 'rgba(255, 250, 235, 0.5)',
    color: '#C6B071',
    backgroundChildColor: '#F7EFD7'
  },
  {
    backgroundColor: '#F9F5FF',
    backgroundColorTable: 'rgba(230, 222, 242, 0.5)',
    color: '#AE97D2',
    backgroundChildColor: '#EDE6F9'
  },
  {
    backgroundColor: '#F2F4F7',
    backgroundColorTable: 'rgba(225, 228, 232, 0.5)',
    color: '#9FB1CD',
    backgroundChildColor: '#E5E9EF'
  },
  {
    backgroundColor: '#FFF6ED',
    backgroundColorTable: 'rgba(246, 231, 215, 0.5)',
    color: '#CFAB87',
    backgroundChildColor: '#F6E9DC'
  },
  {
    backgroundColor: '#FFF1F3',
    backgroundColorTable: 'rgba(243, 223, 226, 0.5)',
    color: '#DCA2AB',
    backgroundChildColor: '#FCE6E9'
  },
  {
    backgroundColor: '#FCE7F6',
    backgroundColorTable: 'rgba(248, 212, 238, 0.5)',
    color: '#D294C2',
    backgroundChildColor: '#F0D6E9'
  },
  {
    backgroundColor: '#EFF8FF',
    backgroundColorTable: 'rgba(214, 229, 241, 0.5)',
    color: '#98BBD6',
    backgroundChildColor: '#DFECF6'
  },
  {
    backgroundColor: '#F7FFF0',
    backgroundColorTable: 'rgba(224, 236, 214, 0.5)',
    color: '#98B57E',
    backgroundChildColor: '#EAF6DF'
  },
  {
    backgroundColor: '#FFF0F0',
    backgroundColorTable: 'rgba(248, 224, 224, 0.5)',
    color: '#CF9999',
    backgroundChildColor: '#F8E2E2'
  },
  {
    backgroundColor: '#dfdddd',
    backgroundColorTable: 'rgba(205, 212, 223, 0.5)',
    color: '#B9B5B5',
    backgroundChildColor: '#F2F2F2'
  }
];
